module.exports = __webpack_public_path__ + "68a6b541b52c066d2e473d4d2021499c.fbx";